import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { LucideAngularModule } from 'lucide-angular';
import { derivedAsync } from 'ngxtension/derived-async';
import { map, Observable, timer } from 'rxjs';
import { HumanizeTimePipe } from 'src/shared/pipes/humanize-time/humanize-time.pipe';

export type VetCareServiceCardType = 'Vet-Call' | 'Vet-Call-Highlighted' | 'Vet-Chat' | 'Vet-Chat-Active';
/**
 * Component for the vet care service card.
 * This component displays a card for a vet care service.
 */
@Component({
  selector: 'app-vet-care-service-card',
  imports: [NgStyle, SvgIconComponent, LucideAngularModule, NgTemplateOutlet, HumanizeTimePipe],
  templateUrl: './vet-care-service-card.component.html',
  styleUrl: './vet-care-service-card.component.scss',
})
export class VetCareServiceCardComponent {
  title = input<string>('');
  subtitle = input<string>('');
  status = input<'available' | 'unavailable' | 'busy' | 'paymentRequired' | null>(null);
  type = input<VetCareServiceCardType>('Vet-Call');
  statusText = input<string>('');
  statusColor = computed(() => {
    switch (this.status()) {
      case 'available':
        return '#20e070';
      case 'unavailable':
        return '#ff3b30';
      case 'busy':
      case 'paymentRequired':
        return '#FBBF24';
      default:
        return;
    }
  });
  inActiveChat = input<boolean>(false);
  iconSrc = input<string>('');
  lastVetReply = input<Date | null>(null);
  unreadMessageCount = input<number>(0);
  iconType = computed(() => {
    const url = this.iconSrc();
    if (!url) return null;
    const cleanUrl = url.split('?')[0];
    const extension = cleanUrl.split('.').pop() || '';
    return extension === 'svg' ? 'svg' : this.supportedImageTypes.includes(extension) ? 'image' : null;
  });
  private supportedImageTypes = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'];
  now = derivedAsync(() => this.getCurrentTime(), { initialValue: new Date().toISOString() });

  /**
   * Observable to get an updated time every 5 seconds
   * @returns Observable of ISO string of the current time
   */
  getCurrentTime(): Observable<string> {
    return timer(0, 5000).pipe(map(() => new Date().toISOString()));
  }
}
